module.exports = __webpack_public_path__ + "static/media/ma-mock-up-cart-2.2d6ddc31.png";